import moment from 'moment';
import { humanize } from 'underscore.string';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Translation, withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { getCircleButtonClass } from '../../../v2/buttons/CircleButton';
import DownloadIcon from '../../../v2/icons/DownloadIcon';
import CheckIcon from '../../../v2/icons/CheckIcon';
import XIcon from '../../../v2/icons/XIcon';
import Badge from '../../../v2/Badge';
import { getPayoutStatusColor } from './colors';
import Checkbox from '../../../v2/forms/Checkbox';
import { getSignedUrl, getDocumentsV2, } from '../../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../../stores/ToastStore';
import { sluggify } from '../../../../utils/localization/utils';
export class RawCell extends Component {
    render() {
        const output = this.props.data || this.props.default || '';
        return React.createElement("td", { className: this.props.className }, output);
    }
}
export class DateCell extends Component {
    render() {
        const output = this.props.data || this.props.default || '';
        return React.createElement("td", null, moment(output).format('L'));
    }
}
class DownloadPDFButton extends Component {
    constructor() {
        super(...arguments);
        this.openSignedUrl = (payout) => async (event) => {
            var _a, _b, _c;
            const { t } = this.props;
            const queryOptions = {
                limit: 1,
                order: {
                    field: 'createdAt',
                    direction: 'desc',
                },
            };
            event.preventDefault();
            try {
                const { data: documentPayout, errors: documentErrors } = await getDocumentsV2([payout._id], null, queryOptions);
                if (documentErrors) {
                    showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', {
                        error: documentErrors[0].message,
                    }), 'error');
                    return;
                }
                const { data, errors: signedUrlErrors } = await getSignedUrl((_b = (_a = documentPayout.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents[0]) === null || _b === void 0 ? void 0 : _b.key);
                if (signedUrlErrors) {
                    showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                        error: signedUrlErrors[0].message,
                    }), 'error');
                    return;
                }
                const url = (_c = data === null || data === void 0 ? void 0 : data.getSignedUrl) === null || _c === void 0 ? void 0 : _c.signedUrl;
                window.open(url, 'new');
            }
            catch (e) {
                console.error('payouts/renderer: error getting signed url: ', e);
            }
        };
    }
    render() {
        const { payout, t } = this.props;
        return (React.createElement("a", { href: payout.number, title: t('DOWNLOAD_PDF'), className: getCircleButtonClass({
                color: 'green',
                className: 'button-with-icon',
            }), onClick: this.openSignedUrl(payout) },
            React.createElement(DownloadIcon, null)));
    }
}
DownloadPDFButton.propTypes = {
    payout: PropTypes.object.isRequired,
};
export default withTranslation()(DownloadPDFButton);
export class CarrierPayoutNumberCell extends Component {
    render() {
        const payout = this.props.data;
        return (React.createElement("td", null,
            React.createElement(Link, { to: '/carrier-payouts/' + payout._id }, payout.number)));
    }
}
export class PayoutNumberCell extends Component {
    render() {
        const payout = this.props.data;
        return (React.createElement("td", null,
            React.createElement(Link, { to: '/payouts/' + payout._id }, payout.number)));
    }
}
export class PayoutStatusCell extends Component {
    render() {
        const payoutStatus = this.props.data;
        const color = getPayoutStatusColor(payoutStatus);
        return (React.createElement("td", null,
            React.createElement(Badge, { color: color, key: payoutStatus },
                React.createElement(Translation, null, (t, { i18n }) => React.createElement(React.Fragment, null, t(sluggify(payoutStatus)))))));
    }
}
export const BooleanCell = ({ data }) => {
    let icon;
    let color;
    if (data) {
        icon = React.createElement(CheckIcon, null);
        color = 'green';
    }
    else {
        icon = React.createElement(XIcon, null);
        color = 'red';
    }
    return (React.createElement("td", null,
        React.createElement("div", { className: getCircleButtonClass({ color }) }, icon)));
};
export class MoneyCell extends Component {
    render() {
        const { data: amount, currency } = this.props;
        return React.createElement("td", null, formatMoney(amount, currency));
    }
}
export class PayoutHistoryCell extends Component {
    render() {
        let report = '';
        const ev = this.props.data.pop();
        if (ev) {
            report = `${humanize(ev.event)} ${moment(ev.timestamp).format('L')} - by ${ev.user || 'Unknown user'}`;
        }
        return (React.createElement("td", null,
            React.createElement("p", null, report)));
    }
}
export const ActionsCell = ({ approveAction, declineAction, approveColor, declineColor, disableApprove, disableDecline, }) => {
    const checkColor = approveColor || 'green';
    const xColor = declineColor || 'red';
    return (React.createElement("td", null,
        React.createElement("div", { className: "flex justify-between" },
            React.createElement("span", { disabled: disableApprove, className: getCircleButtonClass({
                    color: checkColor,
                    disabled: disableApprove,
                }), onClick: !disableApprove && approveAction },
                React.createElement(CheckIcon, null)),
            React.createElement("span", { disabled: disableDecline, className: getCircleButtonClass({
                    color: xColor,
                    disabled: disableDecline,
                }), onClick: !disableDecline && declineAction },
                React.createElement(XIcon, null)))));
};
export const PayoutCheckBoxCell = ({ payoutId, checked, handleToggleCheck, disabled, }) => {
    return (React.createElement("td", null,
        React.createElement(Checkbox, { className: "cursor-pointer", id: payoutId, checked: checked, onChange: () => handleToggleCheck(payoutId), disabled: disabled })));
};
